<div class="main-page-content">
  <div class="main-page-content-block" *ngIf="loadingItem">
    <h1 class="content-heading-font">System Settings</h1>
    <div class="div-loading">Loading system setting...</div>
  </div>
  <div class="main-page-content-block" *ngIf="!currentItem && !loadingItem">
    <a class="btn btn-secondary float-end" [routerLink]="['/system-settings/features']">Manage features</a>
    <h1 class="content-heading-font">System Settings</h1>
    <p>Manage the definitions used by enterprise and company settings.</p>
    <p class="alert alert-info" *ngIf="featureID">Showing settings for feature #{{featureID}}. Use Clear filters to show all features.</p>
    <p-table #dt dataKey="ID" [value]="list?.Result || []" [paginator]="true" [rows]="25"
             [loading]="loadingList" [showCurrentPageReport]="true"
             currentPageReportTemplate="Showing {first} to {last} of {totalRecords} settings"
             [rowsPerPageOptions]="[10, 25, 50, 100]" [totalRecords]="list?.FilteredRecords || 0"
             [lazy]="true" (onLazyLoad)="loadTable($event)"
             [multiSortMeta]="[{field: 'FeatureName', order: 1}, {field: 'Name', order: 1}]"
             sortMode="multiple"
             [filters]="{Archived: [{ value: 'false', matchMode: 'contains', operator: 'and'}]}"

             styleClass="p-datatable-sm p-datatable-gridlines p-datatable-striped">
      <ng-template pTemplate="header">
        <tr>
          <th></th>
          <th pSortableColumn="ID" class="d-none d-xl-table-cell text-nowrap">
            # <p-sortIcon field="ID"></p-sortIcon>
            <p-columnFilter type="numeric" field="ID" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="FeatureName" class="d-none d-lg-table-cell text-nowrap">
            Feature <p-sortIcon field="FeatureName"></p-sortIcon>
            <p-columnFilter type="text" field="FeatureName" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Name" class="text-nowrap">
            Name <p-sortIcon field="Name"></p-sortIcon>
            <p-columnFilter type="text" field="Name" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="Description" class="d-none d-md-table-cell text-nowrap">
            Description <p-sortIcon field="Description"></p-sortIcon>
            <p-columnFilter type="text" field="Description" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="SystemSettingType" class="d-none d-xxl-table-cell text-nowrap">
            Type <p-sortIcon field="SystemSettingType"></p-sortIcon>
            <p-columnFilter type="text" field="SystemSettingType" display="menu" [showOperator]="false" [showAddButton]="false"></p-columnFilter>
          </th>
          <th pSortableColumn="ShowOnCompanySettings" class="d-none d-xxl-table-cell text-center text-nowrap">
            Company Settings <p-sortIcon field="ShowOnCompanySettings"></p-sortIcon>
            <p-columnFilter type="boolean" field="ShowOnCompanySettings" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'No', value: 'false' },{ name: 'Yes', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
          </th>
          <th pSortableColumn="ShowOnEnterpriseSettings" class="d-none d-xl-table-cell text-nowrap text-center">
            Enterprise Settings <p-sortIcon field="ShowOnEnterpriseSettings"></p-sortIcon>
            <p-columnFilter type="boolean" field="ShowOnEnterpriseSettings" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'No', value: 'false' },{ name: 'Yes', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
          </th>
          <th pSortableColumn="Archived" class="d-none d-xxl-table-cell text-nowrap text-center">
            Archived <p-sortIcon field="Archived"></p-sortIcon>
            <p-columnFilter type="boolean" field="Archived" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [options]="[{ name: 'Any', value: '' },{ name: 'No', value: 'false' },{ name: 'Yes', value: 'true' }]" [ngModel]="value" placeholder="Any" (onChange)="filter($event.value)" optionLabel="name" optionValue="value">
                </p-dropdown>
              </ng-template>
            </p-columnFilter>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <button *ngIf="canEditClientSettings && !item.Archived" class="btn btn-sm btn-secondary me-1" type="button"
                    (click)="editClientSetting(item)" [attr.aria-label]="'Edit client values for ' + item.Name" title="Edit Client System Setting">
              <i class="pi pi-building"></i>
            </button>
            <a class="btn btn-sm btn-primary" [routerLink]="['/system-settings', item.ID]" [attr.aria-label]="'Edit ' + item.Name" title="Edit">
              <i class="pi pi-pen-to-square"></i>
            </a>
          </td>
          <td class="d-none d-xl-table-cell">{{item.ID}}</td>
          <td class="d-none d-lg-table-cell">{{item.FeatureName}}</td>
          <td>{{item.Name}}</td>
          <td class="d-none d-md-table-cell">{{item.Description}}</td>
          <td class="d-none d-xxl-table-cell">{{item.SystemSettingType}}</td>
          <td class="d-none d-xxl-table-cell text-center">{{item.ShowOnCompanySettings ? 'Yes' : 'No'}}</td>
          <td class="d-none d-xl-table-cell text-center" [class.text-success]="item.ShowOnEnterpriseSettings">{{item.ShowOnEnterpriseSettings ? 'Yes' : 'No'}}</td>
          <td class="d-none d-xxl-table-cell text-center">{{item.Archived ? 'Yes' : 'No'}}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="paginatorleft">
        <button class="btn btn-primary me-2" type="button" (click)="loadTable()" title="Refresh" [disabled]="loadingList">
          <i class="pi pi-refresh" [class.pi-spin]="loadingList"></i>
        </button>
        <button class="btn btn-primary" type="button" (click)="clear(dt)" title="Clear filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr><td colspan="10">No system settings found.</td></tr>
      </ng-template>
    </p-table>
  </div>
  <div class="main-page-content-block" *ngIf="currentItem">
    <button class="btn btn-secondary float-end" type="button" (click)="cancel()" [disabled]="saving">View list</button>
    <button *ngIf="canEditClientSettings && !currentItem.Archived" class="btn btn-secondary float-end me-2" type="button"
            (click)="editClientSetting(currentItem)" [disabled]="saving">Edit Client System Setting</button>
    <h1 class="content-heading-font">#{{currentItem.ID}} - {{currentItem.Name}}</h1>
    <p class="text-muted">Setting: {{currentItem.SystemSetting}}. IDs, storage types and default values cannot be changed.</p>
    <p class="alert alert-info">The storage type and default value are defined by SystemSettingAttribute and cannot be edited.</p>
    <form [formGroup]="form" (ngSubmit)="save()">
      <fieldset [disabled]="saving">
        <div class="row">
          <div class="col-12 mb-3">
            <label for="settingName">Name</label>
            <input id="settingName" class="form-control" formControlName="Name" maxlength="128" />
          </div>
          <div class="col-12 mb-3">
            <label for="settingDescription">Description</label>
            <textarea id="settingDescription" class="form-control" formControlName="Description" maxlength="1000" rows="3"></textarea>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label for="settingType">Storage type</label>
            <p-dropdown inputId="settingType" class="form-control" formControlName="SystemSettingTypeID"
                        [options]="types" optionValue="ID" optionLabel="SystemSettingType"></p-dropdown>
          </div>
          <div class="col-12 col-md-6 mb-3" [class.div-loading]="loadingLookups">
            <label for="settingFeature">Feature <a class="ms-2" [routerLink]="['/system-settings/features']" *ngIf="!saving">Manage features</a></label>
            <p-dropdown inputId="settingFeature" class="form-control" formControlName="SystemFeatureID"
                        [options]="features" optionValue="ID" optionLabel="Name" [filter]="true"></p-dropdown>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label for="settingOrder">Display order</label>
            <input id="settingOrder" type="number" step="1" class="form-control" formControlName="SettingOrder" />
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label for="settingDefaultValue">Default value (JSON)</label>
            <input id="settingDefaultValue" class="form-control" formControlName="DefaultValue" placeholder="No declared default" readonly />
          </div>
          <div class="col-12 mb-3">
            <div class="form-check">
              <input id="showOnCompanySettings" type="checkbox" class="form-check-input" formControlName="ShowOnCompanySettings" />
              <label class="form-check-label" for="showOnCompanySettings">Show on company settings</label>
            </div>
            <div class="form-check">
              <input id="showOnEnterpriseSettings" type="checkbox" class="form-check-input" formControlName="ShowOnEnterpriseSettings" />
              <label class="form-check-label" for="showOnEnterpriseSettings">Show on enterprise settings</label>
            </div>
            <div class="form-check">
              <input id="settingRequired" type="checkbox" class="form-check-input" formControlName="Required" />
              <label class="form-check-label" for="settingRequired">Required</label>
            </div>
            <div class="form-check">
              <input id="settingArchived" type="checkbox" class="form-check-input" formControlName="Archived" />
              <label class="form-check-label" for="settingArchived">Archived</label>
            </div>
          </div>
          <div class="col-12 mb-3">
            <label for="settingOptions">Options (JSON)</label>
            <textarea id="settingOptions" class="form-control" formControlName="Settings" maxlength="4000" rows="5" spellcheck="false"></textarea>
          </div>
          <div class="col-12 text-center">
            <button class="btn btn-lg btn-primary" type="submit" [class.button-loading]="saving" [disabled]="saving || loadingLookups">Save</button>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</div>

<p-dialog [header]="'Edit ' + (clientSetting?.Name || 'Client System Setting') + ' on client'" [modal]="true" [(visible)]="clientVisible"
          styleClass="p-dialog-lg" [style]="{width: '60rem', maxWidth: '95vw'}"
          [closable]="!clientSaving" [closeOnEscape]="!clientSaving">
  <ng-container *ngIf="clientVisible && clientSetting">
    <p>{{clientSetting.Description}}</p>
    <label for="settingClientID">Client</label>
    <select id="settingClientID" class="form-select mb-3" [(ngModel)]="clientID" [disabled]="loadingClients || clientSaving">
      <option [ngValue]="null">Select a client...</option>
      <option *ngFor="let client of clients" [ngValue]="client.ID">
        {{client.SiteName}} - {{client.BusinessName}} {{client.Active ? '' : '[Inactive]'}}
      </option>
    </select>
    <p *ngIf="loadingClients" role="status">Loading clients...</p>
    <button *ngIf="!loadingClients && !clients" class="btn btn-outline-secondary mb-3" type="button"
            (click)="editClientSetting(clientSetting)">Reload Clients</button>
    <app-client-system-settings *ngIf="clientID && clientSetting.ID" [clientID]="clientID" [systemSettingID]="clientSetting.ID"
                               (savingChange)="clientSaving = $event"></app-client-system-settings>
    <div class="text-end mt-3">
      <button class="btn btn-secondary" type="button" [disabled]="clientSaving" (click)="clientVisible = false">Close</button>
    </div>
  </ng-container>
</p-dialog>
